import React, { useState } from "react";
import FileUpload from "./fileUpload";
import {
  BULKCOUNTERSELLCUSTOMERIMPORT,
  BULKIMPORTMPORT,
  BULKSERVICESIMPORT,
} from "../../utils/api";
import DynamicBreadcrumbs from "../../common/Breadcrumb";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { Box, Button, Container, Grid, Typography } from "@mui/material";
import downloadIcon from "../../assets/downloadIcon.png";
import uploadIcon from "../../assets/uploadIcon.png";

const ExcelUpload = () => {
  const downloadFile = (url, fileName) => {
    const fileUrl = url;
    const link = document.createElement("a"); // Create a link
    link.href = fileUrl; // Set the href to the file URL
    link.setAttribute("download", fileName); // Set the download attribute with the file name
    document.body.appendChild(link); // Append link to the document
    link.click(); // Trigger download
    document.body.removeChild(link); // Remove the link after download
  };

  return (
    <Box sx={{ p: "17px 30px", background: "#ede9ff", minHeight: "100vh" }}>
      <Grid container alignItems="center" spacing={2}>
        <Grid item xs={12} sx={{}}>
          <Box
            sx={{
              background:
                "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
              padding: "10px",
              paddingLeft: "20px",
              borderRadius: 2,
              color: "#01008B", // optional text color
              textAlign: "left",
            }}
          >
            <Typography
              variant="h6"
              sx={{ fontSize: { xs: "12px", sm: "13px", md: "16px" } }}
            >
              Bulk Upload
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Grid
            container
            sx={{
              p: "10px",
              backgroundColor: "white",
              borderRadius: "12px",
              minHeight: "70vh",
            }}
          >
            <Grid item xs={12}>
              <Grid
                container
                columnSpacing={6}
                paddingX={2}
                sx={{ paddingY: "4px", gap: { xs: 1, sm: 0 } }}
              >
                <Grid
                  item
                  xs={12}
                  sm={6}
                  sx={{ fontSize: { xs: "12px", sm: "13px", md: "15px" } }}
                >
                  <FileUpload
                    api={BULKSERVICESIMPORT}
                    text={"Bulk Services Upload"}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  {/* <Button
                    fullWidth
                    variant="outlined"
                    startIcon={<FileDownloadIcon sx={{ color: "black" }} />}
                    sx={{ borderWidth: "2px", height: "50px" }}
                    onClick={() => {
                      downloadFile("/BulkServicesUpload.xlsx", "BulkServicesUpload.xlsx");
                    }}
                  >
                    Download Services Format
                  </Button> */}
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "45px",
                      color: "#01008B",
                      border: "2px solid #01008B",
                      backgroundColor: "#fff",
                      borderRadius: "5px",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      downloadFile(
                        "/BulkServicesUpload.xlsx",
                        "BulkServicesUpload.xlsx"
                      );
                    }}
                  >
                    <Typography
                      sx={{
                        width: "15%",
                        textAlign: "right",
                        marginTop: "5px",
                        paddingRight: "50px",
                      }}
                    >
                      <img
                        src={downloadIcon}
                        style={{ height: "25px" }}
                        alt="icon"
                      />
                    </Typography>
                    <Typography
                      sx={{
                        flexGrow: 1,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        fontWeight: 600,
                      }}
                    >
                      Download Service Format
                    </Typography>
                  </Box>
                </Grid>
              </Grid>

              <Grid
                container
                columnSpacing={6}
                paddingX={2}
                sx={{ paddingY: "4px", gap: { xs: 1, sm: 0 } }}
              >
                <Grid item xs={12} sm={6}>
                  <FileUpload
                    api={BULKIMPORTMPORT}
                    text={"Bulk Products Upload"}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  {/* <Button
                    fullWidth
                    startIcon={<FileDownloadIcon sx={{ color: "black" }} />}
                    variant="outlined"
                    sx={{ borderWidth: "2px", height: "50px" }}
                    onClick={() => {
                      downloadFile("/BulkProductUpload.xlsx", "BulkProductUpload.xlsx");
                    }}
                  >
                    Download Products Format
                  </Button> */}
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "45px",
                      color: "#01008B",
                      border: "2px solid #01008B",
                      backgroundColor: "#fff",
                      borderRadius: "5px",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      downloadFile(
                        "/BulkProductUpload.xlsx",
                        "BulkProductUpload.xlsx"
                      );
                    }}
                  >
                    <Typography
                      sx={{
                        width: "15%",
                        textAlign: "right",
                        marginTop: "5px",
                        paddingRight: "50px",
                      }}
                    >
                      <img
                        src={downloadIcon}
                        style={{ height: "25px" }}
                        alt="icon"
                      />
                    </Typography>
                    <Typography
                      sx={{
                        flexGrow: 1,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        fontWeight: 600,
                      }}
                    >
                      Download Product Format
                    </Typography>
                  </Box>
                </Grid>
              </Grid>

              <Grid
                container
                columnSpacing={6}
                paddingX={2}
                sx={{ paddingY: "4px", gap: { xs: 1, sm: 0 } }}
              >
                <Grid item xs={12} sm={6}>
                  <FileUpload
                    api={BULKCOUNTERSELLCUSTOMERIMPORT}
                    text={"Bulk Customers Info Upload"}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  {/* <Button
                    startIcon={<FileDownloadIcon sx={{color: "black"}} />}
                    fullWidth
                    variant="outlined"
                    sx={{ borderWidth: "2px", height: "50px" }}
                    onClick={() => {
                      downloadFile("/BulkCustomerUpload.xlsx", "BulkCustomerUpload.xlsx");
                    }}
                  >
                    Download Format
                  </Button> */}
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "45px",
                      color: "#01008B",
                      border: "2px solid #01008B",
                      backgroundColor: "#fff",
                      borderRadius: "5px",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      downloadFile(
                        "/BulkCustomerUpload.xlsx",
                        "BulkCustomerUpload.xlsx"
                      );
                    }}
                  >
                    <Typography
                      sx={{
                        width: "15%",
                        textAlign: "right",
                        marginTop: "5px",
                        paddingRight: "50px",
                      }}
                    >
                      <img
                        src={downloadIcon}
                        style={{ height: "25px" }}
                        alt="icon"
                      />
                    </Typography>
                    <Typography
                      sx={{
                        flexGrow: 1,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        fontWeight: 600,
                      }}
                    >
                      Download Customer Info Format
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ExcelUpload;
